import { Link, useSearchParams } from "react-router-dom";
import HeroScreenImg from "../../assets/home/hero-screen.png";
import Star from "../../assets/star.png";
import { Button } from "../ui/button"; // можна лишити — ми просто передаємо свій className
import style from "./Home.module.css";
import Marquee from "./Maquee";
import VerticalCardsSlider from "./VerticalCardsSlider";

const Home = ({ cta = "signup" }) => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const loginLink = code ? `/login?code=${code}` : "/login?mode=signup";

  return (
    <div className={style.home}>
      <section className={`${style.banner} ${style.section}`}>
        <div className={style.bannerContent}>
          <h1 className={style.bannerTitle}>
            Від постановки OKR до&nbsp;результатів — усе&nbsp;в&nbsp;одному інструменті
          </h1>
          <ul className={style.bannerList}>
            <li>Визначте цілі та ключові результати </li>
            <li>Відслідковуйте прогрес</li>
            <li>Отримуйте прозорі результати</li>
          </ul>
          <img className={`${style.star} ${style.bannerStar}`} src={Star} alt="" />
          <div className={style.buttonContainer}>
            {cta === "signup" ? (
              <>
                <Button asChild size="lg" className={style.homeMainButton}>
                  <Link to={loginLink} className="event-signup">Спробуйте безоплатно</Link>
                </Button>
                <p className={style.smallText}>14 днів безоплатний пробний період</p>
              </>
            ) : (
              <Button asChild size="lg" className={style.homeMainButton}>
                <a
                  href="https://calendar.app.google/DWPyEoac1eqkgqXbA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="event-request-demo"
                >
                  Записатися на демо
                </a>
              </Button>
            )}
          </div>
        </div>

        <div className={style.bannerImg}>
          <img src={HeroScreenImg} alt="" />
        </div>
      </section>

      <section className={`${style.challenges} ${style.section}`}>
        <img className={`${style.star} ${style.challengeStar}`} src={Star} alt="" />
        <h2 className={style.subtitle}>
          Чому з року в рік ви не можете досягти <span>бізнес цілей</span>?
        </h2>
        <p className={style.challengesText}>
          Більшість команд стикаються з однаковими викликами, впроваджуючи стратегічні цілі.
        </p>
        <div className={style.challengesList}>
          <div>Реагуєте на факапи бізнесу, коли вони вже сталися?</div>
          <div>Працюєте лише на утримання бізнесу, а&nbsp;не&nbsp;на&nbsp;розвиток?</div>
          <div>Команда рухається в різному темпі та&nbsp;напрямах?</div>
          <div>Пояснюєте прогрес команді, топам чи&nbsp;інвесторам в&nbsp;екселі?</div>
        </div>
      </section>

      <h2 className={style.subtitle}>Як це працює?</h2>
      <VerticalCardsSlider />

      <div className={style.center}>
        {cta === "signup" ? (
          <Button asChild size="lg" className={style.homeMainButton}>
            <Link to={loginLink} className="event-signup">Спробуйте безкоштовно</Link>
          </Button>
        ) : (
          <Button asChild size="lg" className={style.homeMainButton}>
            <a
              href="https://calendar.app.google/DWPyEoac1eqkgqXbA"
              target="_blank"
              rel="noopener noreferrer"
              className="event-request-demo"
            >
              Записатися на демо
            </a>
          </Button>
        )}
      </div>

      <section className={`${style.forWhom} ${style.section}`}>
        <h2 className={style.subtitle}>
          Кому підійде <span>OKboard?</span>
        </h2>
        <div className={style.whomList}>
          <div className={style.whomCard}>
            <p className={style.whomTitle}>Отримуйте прозору звітність і&nbsp;контролюйте прогрес —</p>
            <p className={style.whomSubtitle}>лідерам, топменеджерам і&nbsp;їхнім командам</p>
          </div>

          <div className={style.whomCard}>
            <p className={style.whomTitle}>Ефективно досягайте стратегічних цілей&nbsp;—</p>
            <p className={style.whomSubtitle}>стартапам, малому та&nbsp;середньому бізнесу</p>
          </div>

          <div className={style.whomCard}>
            <p className={style.whomTitle}>Впорядкуйте процеси і&nbsp;моніторинг результатів —</p>
            <p className={style.whomSubtitle}>
              неурядовим організаціям і&nbsp;державним установам, які цифровізуються
            </p>
          </div>

          <div className={style.whomCard}>
            <p className={style.whomTitle}>Розумійте свій внесок у&nbsp;загальний результат —</p>
            <p className={style.whomSubtitle}>будь-яким командам, які працюють за системою OKR</p>
          </div>
        </div>
        <img className={`${style.star} ${style.whomStar}`} src={Star} alt="" />
      </section>

      <section className={style.whyUs}>
        <h2 className={style.subtitle}>
          Чому саме <span>OKboard</span>?
        </h2>
        <svg className={style.whyPath} width="1440" height="513" viewBox="0 0 1440 513" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M-325.059 58.8893C-325.059 58.8893 -428.52 406.545 217.761 476.974C864.042 547.402 1619.78 270.336 1622.85 236.226" stroke="#D1D1D1" strokeDasharray="10 10"/>
          <path d="M1240.05 370.752L1243.33 369.728L1247.31 372.805L1252.04 371.331L1244.56 362.143L1248.5 360.914L1259.12 369.119L1264.9 367.317C1265.62 367.092 1266.32 367.156 1266.99 367.51C1267.67 367.863 1268.12 368.401 1268.34 369.123C1268.57 369.845 1268.5 370.543 1268.15 371.217C1267.79 371.891 1267.26 372.341 1266.54 372.567L1260.76 374.368L1256.69 387.16L1252.75 388.389L1253.68 376.58L1248.95 378.054L1247.42 382.851L1244.14 383.875L1244.06 376.699L1240.05 370.752Z" fill="#D1D1D1"/>
        </svg>

          <div className={style.whyUsList}>
          <svg className={style.whyPathMobile} width="192" height="559" viewBox="0 0 192 559" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M131.83 76.3459L130.435 72.8193L133.495 68.1831L131.487 63.1048L121.987 72.0823L120.313 67.8503L128.474 55.4873L126.019 49.2805C125.712 48.5046 125.726 47.7312 126.06 46.9602C126.394 46.1891 126.949 45.6502 127.725 45.3433C128.5 45.0365 129.274 45.05 130.045 45.384C130.816 45.718 131.355 46.2729 131.662 47.0488L134.117 53.2556L148.526 56.6918L150.2 60.9237L137.129 60.8731L139.138 65.9514L144.542 67.24L145.936 70.7666L138.046 71.4403L131.83 76.3459Z" fill="#D1D1D1"/>
            <path d="M0.110928 556.222C0.110928 556.222 144.991 588.786 182.948 404.506C220.906 220.226 114.128 1.66716 99.8216 0.498371" stroke="#D1D1D1" strokeDasharray="10 10"/>
          </svg>
            <div className={style.whyItem}>
              <div className={style.whomIcon}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_280_129" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect width="24" height="24" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_280_129)">
                    <path d="M9.19225 2.75V1.25H14.8077V2.75H9.19225ZM12 21.5C10.8308 21.5 9.73083 21.2769 8.7 20.8307C7.66917 20.3846 6.76792 19.7756 5.99625 19.0038C5.22442 18.2321 4.61542 17.3308 4.16925 16.3C3.72308 15.2692 3.5 14.1692 3.5 13C3.5 11.8308 3.72308 10.7308 4.16925 9.7C4.61542 8.66917 5.22442 7.76792 5.99625 6.99625C6.76792 6.22442 7.66917 5.61542 8.7 5.16925C9.73083 4.72308 10.8308 4.5 12 4.5C13.0013 4.5 13.9657 4.66992 14.8932 5.00975C15.8207 5.34942 16.682 5.83592 17.477 6.46925L18.723 5.22325L19.7768 6.277L18.5307 7.523C19.1641 8.318 19.6506 9.17925 19.9902 10.1068C20.3301 11.0343 20.5 11.9987 20.5 13C20.5 14.1692 20.2769 15.2692 19.8307 16.3C19.3846 17.3308 18.7756 18.2321 18.0038 19.0038C17.2321 19.7756 16.3308 20.3846 15.3 20.8307C14.2692 21.2769 13.1692 21.5 12 21.5ZM12 20C13.9333 20 15.5833 19.3167 16.95 17.95C18.3167 16.5833 19 14.9333 19 13C19 11.0667 18.3167 9.41667 16.95 8.05C15.5833 6.68333 13.9333 6 12 6C10.0667 6 8.41667 6.68333 7.05 8.05C5.68333 9.41667 5 11.0667 5 13C5 14.9333 5.68333 16.5833 7.05 17.95C8.41667 19.3167 10.0667 20 12 20ZM10.1923 16.5385L15.5 13L10.1923 9.4615V16.5385Z" fill="#333333"/>
                    </g>
                  </svg>
              </div>
              <div>
              <p className={style.whyTitle}>Швидкий старт</p>
              <p className={style.whySubtitle}>Онбординг нового користувача та команди займає менше 
                30 хв — від реєстрації до першої статистики за вашими OKR.
              </p>
              </div>
            </div>

            <div className={style.whyItem}>
              <div className={style.whomIcon}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_280_141" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect width="24" height="24" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_280_141)">
                    <path d="M5.30775 19.5C4.80258 19.5 4.375 19.325 4.025 18.975C3.675 18.625 3.5 18.1974 3.5 17.6923V6.30775C3.5 5.80258 3.675 5.375 4.025 5.025C4.375 4.675 4.80258 4.5 5.30775 4.5H9.05775V6H5.30775C5.23075 6 5.16025 6.03208 5.09625 6.09625C5.03208 6.16025 5 6.23075 5 6.30775V17.6923C5 17.7692 5.03208 17.8398 5.09625 17.9038C5.16025 17.9679 5.23075 18 5.30775 18H9.05775V19.5H5.30775ZM11.25 21.5V2.5H12.75V4.5H18.6923C19.1974 4.5 19.625 4.675 19.975 5.025C20.325 5.375 20.5 5.80258 20.5 6.30775V17.6923C20.5 18.1974 20.325 18.625 19.975 18.975C19.625 19.325 19.1974 19.5 18.6923 19.5H12.75V21.5H11.25ZM12.75 18H18.6923C18.7692 18 18.8398 17.9679 18.9038 17.9038C18.9679 17.8398 19 17.7692 19 17.6923V6.30775C19 6.23075 18.9679 6.16025 18.9038 6.09625C18.8398 6.03208 18.7692 6 18.6923 6H12.75V18Z" fill="#333333"/>
                    </g>
                  </svg>

              </div>
              <div>
              <p className={style.whyTitle}>Інтуїтивний інтерфейс</p>
              <p className={style.whySubtitle}>Працює за принципом what
                you see is what you get: те, що ви вводите, має таким самий вигляд, як і на фінальному дашборді.
              </p>
              </div>
            </div>

            <div className={style.whyItem}>
              <div className={style.whomIcon}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_280_135" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect width="24" height="24" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_280_135)">
                    <path d="M10.1539 17.75V16.25H11.5694L14.4059 13L11.5694 9.75H9.78461L8.18461 18.148C8.02578 19.0007 7.72553 19.6475 7.28386 20.0885C6.8422 20.5295 6.27194 20.75 5.57311 20.75C4.90644 20.75 4.36228 20.5693 3.94061 20.2078C3.51878 19.8461 3.30786 19.3673 3.30786 18.7712C3.30786 18.3212 3.42544 17.9593 3.66061 17.6855C3.89594 17.4118 4.19503 17.275 4.55786 17.275C4.90403 17.275 5.19886 17.3943 5.44236 17.6328C5.68603 17.8713 5.80786 18.1584 5.80786 18.4943C5.80786 18.6289 5.77803 18.7472 5.71836 18.849C5.65869 18.951 5.58528 19.0308 5.49811 19.0885C5.53011 19.1205 5.57503 19.1477 5.63286 19.1702C5.69053 19.1926 5.75461 19.2038 5.82511 19.2038C6.04311 19.1936 6.22136 19.0933 6.35986 18.903C6.49819 18.7125 6.60969 18.4192 6.69436 18.023L8.25411 9.75H5.34636V8.25H8.53286L9.03861 5.5155C9.16811 4.81167 9.45819 4.25808 9.90886 3.85475C10.3595 3.45158 10.9124 3.25 11.5674 3.25C12.2239 3.25 12.7629 3.44267 13.1846 3.828C13.6064 4.21317 13.8174 4.69867 13.8174 5.2845C13.8174 5.714 13.6998 6.06567 13.4646 6.3395C13.2293 6.61317 12.9302 6.75 12.5674 6.75C12.2212 6.75 11.9264 6.63233 11.6829 6.397C11.4392 6.16183 11.3174 5.87117 11.3174 5.525C11.3174 5.39033 11.3472 5.27208 11.4069 5.17025C11.4665 5.06825 11.5431 4.98842 11.6366 4.93075C11.6046 4.89225 11.5549 4.86017 11.4876 4.8345C11.4203 4.809 11.3514 4.79625 11.2809 4.79625C11.0719 4.81675 10.9055 4.90842 10.7819 5.07125C10.6582 5.23408 10.5636 5.47508 10.4981 5.79425L10.0731 8.25H14.6539V9.75H13.5559L15.4039 11.8598L17.2521 9.75H16.1539V8.25H20.6539V9.75H19.2386L16.4021 13L19.2481 16.25H20.6539V17.75H16.1539V16.25H17.2521L15.4039 14.125L13.5559 16.25H14.6539V17.75H10.1539Z" fill="#333333"/>
                    </g>
                  </svg>

              </div>
              <div>
              <p className={style.whyTitle}>Автоматичні розрахунки</p>
              <p className={style.whySubtitle}>Відсоток виконання цілей і динаміка змін за останній місяць рахуються самі.
              </p>
              </div>
            </div>

            <div className={style.whyItem}>
              <div className={style.whomIcon}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_280_147" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                    <rect width="24" height="24" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_280_147)">
                    <path d="M3.5 19.4999V7.99994L7.1155 10.7114L12.0963 3.72119L16.827 7.49994H20.5V19.4999H3.5ZM8 16.9999L12 11.4999L19 16.9499V8.99994H16.3L12.4 5.87494L7.45 12.8249L5 10.9999V14.5999L8 16.9999Z" fill="#333333"/>
                    </g>
                  </svg>

              </div>
              <div>
              <p className={style.whyTitle}>Наочна візуалізація</p>
              <p className={style.whySubtitle}>
                Дашборд має стильний вигляд, зрозумілий для демонстрації менеджменту або інвесторам.
              </p>
              </div>
            </div>
          </div>
          <div className={style.center}>
          {cta === "signup" ? (
            <Button asChild size="lg" className={style.homeMainButton}>
              <Link to={loginLink} className="event-signup">Спробуйте безоплатно</Link>
            </Button>
          ) : (
            <Button asChild size="lg" className={style.homeMainButton}>
              <a
                href="https://calendar.app.google/DWPyEoac1eqkgqXbA"
                target="_blank"
                rel="noopener noreferrer"
                className="event-request-demo"
              >
                Записатися на демо
              </a>
            </Button>
          )}
        </div>
          
          <div className={style.numbers}>
            <div className={style.numberCard}>
              <div>
                <p>Компанії з регулярним відстеженням OKR перевершують конкурентів на&nbsp;49&nbsp;%</p>
                <svg width="34" height="19" viewBox="0 0 34 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.8 0L27.693 3.62583L19.397 11.3525L12.597 5.01917L0 16.7675L2.397 19L12.597 9.5L19.397 15.8333L30.107 5.87417L34 9.5V0H23.8Z" fill="white"/>
                </svg>
              </div>
              <div>
                <p className={style.bigNumber}>49<sup>%</sup></p>
                <p>Джерело: Deloitte</p>
              </div>
            </div>

               <div className={style.numberCard}>
              <div>
                <p>70 % працівників почуваються більш мотивованими, коли бачать вплив своїх завдань на&nbsp;загальні цілі</p>
                <svg width="34" height="19" viewBox="0 0 34 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.8 0L27.693 3.62583L19.397 11.3525L12.597 5.01917L0 16.7675L2.397 19L12.597 9.5L19.397 15.8333L30.107 5.87417L34 9.5V0H23.8Z" fill="white"/>
                </svg>
              </div>
              <div>
                <p className={style.bigNumber}>70<sup>%</sup></p>
                <p>Джерело: Gallup</p>
              </div>
            </div>
          </div>
          
          <div className={style.numberArrow}>
            <svg width="56" height="51" viewBox="0 0 56 51" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M44.1694 49.9094C20.1451 30.0102 11.7391 9.35201 11.7391 9.35201" stroke="#D1D1D1" strokeWidth="1.4" strokeMiterlimit="10"/>
              <path d="M7.08491 19.2714L8.51274 3.12513L24.5094 11.1055" stroke="#D1D1D1" strokeWidth="1.4" strokeMiterlimit="10"/>
            </svg>

            <p>Компанії, які впроваджують OKR, рухаються до цілей швидше та впевненіше</p>
          </div>
          <img className={`${style.star} ${style.numberStar}`} src={Star} alt=""/>
        </section>

        <section className={`${style.partners} ${style.section}`}>
          <h2 className={style.subtitle}>Доказ — <span>у партнерстві</span></h2>
          <p className={style.partnersText}>Річ не лише в технологіях. Організації обирають OKboard, тому що ми орієнтовані на продукт та партнерство.</p>
          <Marquee />
        
        </section>

        <section className={`${style.section} ${style.tariffs}`}>
        <img className={`${style.star} ${style.tariffStar}`} src={Star} alt=""/>
          <h2 className={style.subtitle}><span>Зручні тарифні плани</span> для&nbsp;будь-яких організацій</h2>
          <p className={style.tariffSubtitle}>Ми подбали, щоб ви сплачували виключно за борди, які використовуєте. Борди, які вам не потрібні, — сміливо архівуйте — вони нікуди не подінуться, їх завжди можна повернути та використовувати.</p>
          <div className={style.tariffList}>
            
            <div className={style.tariffCard}>
              <p className={style.tariffName}>Starter</p>
              <p className={style.tariffBoard}>1 борд</p>
              <div className={style.tariffPrice}>
                <sup>USD</sup>
                <p>30</p>
                <sup>/міс</sup>
              </div>
              <p className={style.tariffYearPrice}>289 USD на рік</p>
              { cta === "signup" ? (
                <div className={style.tariffButton}>
                  <Link className="event-signup" to={loginLink}>Спробуйте</Link>
                </div>
              ) : (
                <div className={style.tariffButton}>
                  <a className="event-request-demo"
                    href="https://calendar.app.google/DWPyEoac1eqkgqXbA"
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                      Записатися на демо
                  </a>
                </div>
                )}
            </div>

            <div className={style.tariffCard}>
              <p className={style.tariffName}>Growth</p>
              <p className={style.tariffBoard}>До 5 бордів</p>
              <div className={style.tariffPrice}>
                <sup>USD</sup>
                <p>59</p>
                <sup>/міс</sup>
              </div>
              <p className={style.tariffYearPrice}>559 USD на рік</p>
              { cta === "signup" ? (
                <div className={style.tariffButton}>
                  <Link className="event-signup" to={loginLink}>Спробуйте</Link>
                </div>
              ) : (
                <div className={style.tariffButton}>
                  <a className="event-request-demo"
                    href="https://calendar.app.google/DWPyEoac1eqkgqXbA"
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                      Записатися на демо
                  </a>
                </div>
                )}
            </div>

            <div className={style.tariffCard}>
              <p className={style.tariffName}>Business</p>
              <p className={style.tariffBoard}>6+ бордів</p>
              <div className={style.tariffPrice}>
                <sup>USD</sup>
                <p>99</p>
                <sup>/міс</sup>
              </div>
              <p className={style.tariffYearPrice}>949 USD на рік</p>
              { cta === "signup" ? (
                <div className={style.tariffButton}>
                  <Link className="event-signup" to={loginLink}>Спробуйте</Link>
                </div>
              ) : (
                <div className={style.tariffButton}>
                  <a className="event-request-demo"
                    href="https://calendar.app.google/DWPyEoac1eqkgqXbA"
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                      Записатися на демо
                  </a>
                </div>
                )}
            </div>

            <div className={style.tariffCard}>
              <p className={style.tariffName}>Special</p>
              <p className={style.tariffBoard}>Додаткові послуги та консультування</p>
              <p className={style.specialPrice}>Спеціальна ціна</p>
              { cta === "signup" ? (
                <div className={style.tariffButton}>
                  <Link className="event-signup" to={loginLink}>Спробуйте</Link>
                </div>
              ) : (
                <div className={style.tariffButton}>
                  <a className="event-request-demo"
                    href="https://calendar.app.google/DWPyEoac1eqkgqXbA"
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                      Записатися на демо
                  </a>
                </div>
                )}
            </div>
          </div>
        </section>

        <section className={style.trySection}>
        <img className={`${style.star} ${style.tryStar}`} src={Star} alt="" />
        <p>Спробуйте безкоштовний пробний період&nbsp;14&nbsp;днів. Картка не потрібна.</p>

        <div className={`${style.ctaRow} last`}>
          <Link to={loginLink} className={`${style.linkBtnPrimary} first-btn event-signup`}>
            Спробувати безоплатно
          </Link>

          <a
            className={`${style.linkBtnSecondary} secondary-btn event-request-demo`}
            href="https://calendar.app.google/DWPyEoac1eqkgqXbA"
            target="_blank"
            rel="noopener noreferrer"
          >
            Записатися на демо
          </a>
        </div>
      </section>
      </div>
  );
};

export default Home;